import { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { useForm, SubmitHandler } from "react-hook-form";

import CollapsibleTable from "../../components/collapsible-table";
import Avatar from "@mui/material/Avatar";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import TagColor from "../../components/tag-color";
import UploadButton from "../../components/upload-button";
import Drawer from "@mui/material/Drawer";
import TextField from "@mui/material/TextField";
import useClients from "../../hooks/clients";

const ClientsList = () => {
  const { get: getClients, uploadPhoto, create, edit } = useClients();
  const [clients, setClients] = useState<Client[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm<Client>();

  const loadData = useCallback(() => {
    const fn = async () => {
      const resp = await getClients();
      setClients(resp);
    };
    fn();
  }, []);

  const onSubmit: SubmitHandler<Client> = (data) => {
    if (isEdit) {
      edit(data.id, data);
    } else {
      create(data);
    }
    loadData();
    toggleDrawer({});
  };
  const uploadLogo = useCallback(async (userId: string, file: File) => {
    setIsLoading(true);
    await uploadPhoto(userId, file);
    await loadData();
    setIsLoading(false);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const toggleDrawer = ({ isEdit = false }: { isEdit?: boolean }) => {
    setIsEdit(isEdit);
    reset();
    setOpenDrawer(!openDrawer);
  };
  const openEdit = useCallback((client: Client) => {
    console.log(client);
    toggleDrawer({ isEdit: true });
    setValue("id", client.id);
    setValue("address", client.address);
    setValue("name", client.name);
    setValue("email", client.email);
    setValue("phoneNumber", client.phoneNumber);
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        gap: 2,
        padding: "48px",
        paddingTop: "80px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: 2,
          paddingTop: "80px",
          width: "100%",
        }}
      >
        <Button
          size="small"
          variant="contained"
          color="secondary"
          onClick={() => toggleDrawer({})}
        >
          <AddIcon />
          Add client
        </Button>
      </Box>

      <CollapsibleTable
        header={["Account Ref", "Name", "Email", "Phone number", ""]}
        rows={clients.map((client) => {
          return {
            cells: [
              client.id,
              client.name,
              client.email,
              client.phoneNumber,
              <Button
                size="small"
                variant="outlined"
                color="primary"
                onClick={() => openEdit(client)}
              >
                Edit
              </Button>,
            ],
          };
        })}
      />
      <Drawer anchor={"right"} open={openDrawer} onClose={toggleDrawer}>
        <div className="p-[24px] pt-[88px]">
          {isEdit ? "Edit" : "Add"} Client
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-[24px]"
          >
            <TextField
              id="outlined-basic"
              label="Client email"
              variant="outlined"
              {...register("email", { required: true })}
            />
            <TextField
              id="outlined-basic"
              label="Client name"
              variant="outlined"
              {...register("name", { required: true })}
            />
            <TextField
              id="outlined-basic"
              label="Client phone number"
              variant="outlined"
              {...register("phoneNumber", { required: true })}
            />
            <Button type="submit" variant="contained" color="secondary">
              Save
            </Button>
          </form>
        </div>
      </Drawer>
    </Box>
  );
};

export default ClientsList;
